import 'flatpickr/dist/themes/dark.css';
import React, {
  ComponentPropsWithoutRef,
  ComponentPropsWithRef,
  ElementRef,
  forwardRef,
} from 'react';
import Flatpickr from 'react-flatpickr';
import Input from './Input';

type FlatPickrProps = ComponentPropsWithoutRef<typeof Flatpickr>;

type Props = Omit<ComponentPropsWithRef<typeof Input>, 'onChange' | 'value'> & {
  onChange: FlatPickrProps['onChange'];
  value: FlatPickrProps['value'];
  defaultValue: FlatPickrProps['defaultValue'];
  options?: FlatPickrProps['options'];
};

export default forwardRef<ElementRef<typeof Flatpickr>, Props>(
  ({ options, onChange, value, defaultValue, ...inputProps }, forwardedRef) => {
    return (
      <Flatpickr
        ref={forwardedRef}
        value={value}
        options={{ dateFormat: 'm/d/Y h:i K', ...options }}
        onChange={onChange}
        defaultValue={defaultValue}
        render={({ defaultValue }: any, ref: any) => {
          return (
            <Input
              {...inputProps}
              iconCss={{
                left: 15,
              }}
              containerCss={{
                '@bp1': {
                  flex: 1,
                  width: '100%',
                },
              }}
              css={{
                paddingLeft: 40,
                '@bp1': {
                  padding: '12px 16px 12px 48px',
                },
              }}
              ref={ref}
              defaultValue={defaultValue}
            />
          );
        }}
      />
    );
  },
);
